export { default as KYCContainer } from './KYCContainer';
